
import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Card, CardBody, ModalFooter, Button} from 'reactstrap';

const formatter = require('../../../../utils/formatter/formatter');
const translator = require('../../../../utils/translator/translator');

class RefundChargeLinesDialogue extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.selectedRefundableChargeLine = null;
    }

    render()
    {

        var headerComponent = <thead className="thead-dark">
                                    <tr >
                                        <td style={{width:'40%', paddingTop:'25px', paddingBottom:'25px'}}>
                                            {translator.getTranslation('charge_identifier')}
                                        </td>
                                        <td style={{width:'20%', paddingTop:'25px', paddingBottom:'25px'}}>
                                            {translator.getTranslation('charge_amount')}
                                        </td>
                                        <td style={{width:'20%', paddingTop:'25px', paddingBottom:'25px'}}>
                                            {translator.getTranslation('refunded_amount')}
                                        </td>
                                        <td style={{width:'20%', paddingTop:'25px', paddingBottom:'25px'}}>
                                            {translator.getTranslation('refundable_amount')}
                                        </td>
                                    </tr>
                                </thead>;

        let rowComponents = [];
        this.props.refundableChargeLines.forEach (r =>
            {
                let refundableChargeLine = r;
                let backgroundColor = 'white';

                if (refundableChargeLine == this.state.selectedRefundableChargeLine)
                    backgroundColor = "Gray";

                rowComponents.push(<tr onClick={()=>
                                                {
                                                    this.state.selectedRefundableChargeLine = refundableChargeLine;
                                                    this.setState({});
                                                }}>
                                        <td style={{background:backgroundColor, textAlign:'left', paddingTop:'25px', paddingBottom:'25px'}}>{refundableChargeLine.identifier}</td>
                                        <td style={{background:backgroundColor, textAlign:'end', paddingTop:'25px', paddingBottom:'25px'}}>{formatter.convertToCurrencyFormat(refundableChargeLine.amount)}</td>
                                        <td style={{background:backgroundColor, textAlign:'end', paddingTop:'25px', paddingBottom:'25px'}}>{formatter.convertToCurrencyFormat(refundableChargeLine.refunded)}</td>
                                        <td style={{background:backgroundColor, textAlign:'end', paddingTop:'25px', paddingBottom:'25px'}}>{formatter.convertToCurrencyFormat(refundableChargeLine.refundable)}</td>
                                    </tr>);
            });

        let bodyComponent = <tbody>{rowComponents}</tbody>

        return(<div style={{userSelect:'none'}}>
                    <Modal isOpen={true} centered animation={false} fade={false} size="lg">
                        <ModalHeader cssModule={{ 'modal-title': 'w-100' }}>
                            <div className="d-flex justify-content-center">{translator.getLabel("please_select_payment_line")}</div>
                        </ModalHeader>
                        <ModalBody style={{margin:'-10px'}}>
                            <div style={{ overflowX: "hidden", overflowY: "auto", maxHeight: "650px" }}>
                                <table style={{ width: "100%" }} className="pure-table pure-table-bordered pure-table-striped">
                                   {headerComponent}
                                   {bodyComponent}                                
                                </table>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" style={{width:'100px'}} disabled={this.state.selectedRefundableChargeLine == null} onClick={()=>
                            {
                                this.props.onOk(this.state.selectedRefundableChargeLine);
                            }}>{translator.getLabel("ok")}</Button>
                            <Button color="secondary" style={{width:'100px'}} onClick={()=>
                            {
                                this.props.onCancel();
                            }}>{translator.getLabel("cancel")}</Button>
                        </ModalFooter>
                    </Modal>
                </div>);
    }
}

export default RefundChargeLinesDialogue;